import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Smartphone, TabletSmartphoneIcon } from "lucide-react";

const QRCodeSection = () => {
  const [showQR, setShowQR] = useState(false);

  // In a real application, this would be generated dynamically for the current page
  const qrImageUrl =
    "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=" +
    encodeURIComponent(window.location.href);

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-200 p-6">
      {showQR ? (
        <div className="flex flex-col items-center space-y-4 w-full">
          <img
            src={qrImageUrl}
            alt="QR Code to test this page on another device"
            className="w-[200px] h-[200px]"
          />
          <p className="text-sm text-center text-text-muted">
            Scan this code with your mobile/tablet device to test video playback
            there
          </p>
          <Button variant="ghost" size="sm" onClick={() => setShowQR(false)}>
            Hide QR Code
          </Button>
        </div>
      ) : (
        <div className="flex flex-col gap-5 h-full">
          <div className="flex items-start gap-4">
            <div className="shrink-0 size-10 rounded-xl bg-gray-50 border border-gray-100 flex items-center justify-center">
              <TabletSmartphoneIcon className="h-5 w-5 text-brand-500" />
            </div>
            <div className="flex flex-col gap-1">
              <h3 className="text-base font-semibold text-gray-900">Test on Another Device</h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                Make sure you test on all the devices you use to watch videos.
              </p>
            </div>
          </div>
          <div className="mt-auto">
            <Button
              variant="default"
              size="default"
              className="w-full flex items-center justify-center gap-2 bg-brand-500 hover:bg-brand-600 rounded-lg"
              onClick={() => setShowQR(true)}
            >
              <Smartphone className="h-4 w-4" />
              Show QR Code
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default QRCodeSection;
